import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"
import Auth from "auth"
import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import { WarningCallback,ErrorsCallback, SuccessCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsCustomerSurveyUpdate } from "store/actions"
import { thaiBath } from "helpers/ConvertFormat"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import EventNoteIcons from "@material-ui/icons/EventNote"
import SearchIcon from "@material-ui/icons/Search";
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite";
import DeleteForeverIcons from "@material-ui/icons/DeleteForever"
// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";
import Autocomplete from "components/Autocomplete/Select.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
import { ISOToDateYMD, ISOToDateYMDAndFullTime } from "helpers/ConvertDate" 
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Datetime from "react-datetime";

import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { replaceNumberQuestion } from "helpers/ConvertString"
import wordingQuestion from "configs/wordingQuestion.jsx"

const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
var userCode = Auth.getUserData()?Auth.getUserData().user_type_code:10
class ProjectListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSuccessCase:null,
      dataListRaw: [],
      dataList: [],
      dataListMaxFormServer: 0,
      pageName:"รายชื่อลูกค้า",
      currentLeadName: [],
      dataLead: [],
      currentLimit:10,
      limitList:[
        { name: "แสดง 10 รายการแรก", value: 10 },
        { name: "แสดง 20 รายการแรก", value: 20 },
        { name: "แสดง 30 รายการแรก", value: 30 },
        { name: "แสดง 50 รายการแรก", value: 50 },
        { name: "แสดง 100 รายการแรก", value: 100 },
        { name: "แสดง 200 รายการแรก", value: 200 },
        { name: "แสดง 500 รายการแรก", value: 500 },
        { name: "แสดง 1,000 รายการแรก", value: 1000 },
        { name: "แสดง 2,000 รายการแรก", value: 2000 },
        { name: "แสดง 9,999 รายการแรก", value: 9999 },
      ],
      currentFocusStatus:0,
      focusStatusList:[
        { name: "ทุกสถานะ", value: 0 },
        { name: "รอ QC ตรวจ", value: 1 },
        { name: "QC ผ่าน", value: 2 },
        { name: "QC ไม่ผ่าน", value: 3 },
        { name: "รอการโทร", value: 4 },
        { name: "ไม่สำเร็จ", value: 5 },
      ],
      statusDialogOpen: false,
      currentUserName: "", 
      currentData: {},
      dataDealer:[], 
      currentBranchName: [],
      startDateTime:null,
      endDateTime:null,
    }
  }
  componentDidMount() {
    // userCode != 6
    Alert.Loading()
    var dataFocusStatusList = {focusStatusList:this.state.focusStatusList,currentFocusStatus:0}

    if(userCode == 6){//== Agent ==
      dataFocusStatusList.focusStatusList = [ 
        { name: "รอการโทร", value: 4 },
      ]
      dataFocusStatusList.currentFocusStatus = 4
    }
    if(this.props.isSuccessCase){ //== Menu Success Case ==
      dataFocusStatusList.focusStatusList = [
        { name: "รอ QC ตรวจ", value: 1 },
        { name: "QC ผ่าน", value: 2 },
      ]
      dataFocusStatusList.currentFocusStatus = 1
    }
    if(this.props.isSuccessQcCheck){ //== Menu Qc Check ==
      dataFocusStatusList.focusStatusList = [
        { name: "รอ QC ตรวจ", value: 1 },
        { name: "QC ไม่ผ่าน", value: 3 },
      ]
      dataFocusStatusList.currentFocusStatus = 1
    }
    if(this.props.isSuccessQcPass){ //== Menu Success Qc Pass ==
      dataFocusStatusList.focusStatusList = [ 
        { name: "QC ผ่าน", value: 2 },
      ]
      dataFocusStatusList.currentFocusStatus = 2
    }
    this.setState(dataFocusStatusList,()=>{ 
      this.loadSourceLeadDataList(() => {
        this.props.listsCustomerSurveyUpdate(null,null,null,null,null) 
        Alert.LoadingClose()
      })
    })
  }

  componentWillUpdate(nextProps, nextState) { 
    if (nextProps.listsCustomerSurvey.data && nextProps.listsCustomerSurvey.data !== nextState.dataListRaw) {
      var dataList = this.renderListData(nextProps.listsCustomerSurvey.data)
      this.setState({
        dataListMaxFormServer:nextProps.listsCustomerSurvey.max,
        dataListRaw: nextProps.listsCustomerSurvey.data,
        dataList: dataList
      },()=>{
        if(dataList.length > 0){
          Alert.LoadingClose()
        } 
      })
    }
  } 
  loadSourceLeadDataList = (callback) => {
    APIPost( UrlServer.URL_POST_IMPORT_EXCEL_LEAD_SETTING_DATA_LIST,{},({datas})=>{  
      var newConvertDatas = arrayObject(datas,[
          {
            oldKey:"_id",
            newKey:"value"
          },
          {
            oldKey:"description",
            newKey:"label"
          },
          {
            oldKey:"created_date_iso",
            newKey:"created_date_iso"
          },
          {
            oldKey:"total_leads",
            newKey:"total_leads"
          }
        ]
      )
      newConvertDatas.map((data,index)=>{ 
        newConvertDatas[index]["label"] = data["label"] + " : " + ISOToDateYMDAndFullTime(data["created_date_iso"])
      })
      this.setState({  
        dataLead:newConvertDatas
        },()=>{ 
          this.loadDealerDataList(() => {
            callback()
          })
          
        }); 
    })  
  }

  loadDealerDataList = (callback) => {
    APIPost(UrlServer.URL_POST_GET_DEALER, {dealer_code: userCode.dealer_code}, ({ datas }) => {
      var newConvertDatas = arrayObject(datas, [
        {
          oldKey: "dealer_code",
          newKey: "value"
        },
        {
          oldKey: "branch_name",
          newKey: "label"
        }
      ]
      )
      this.setState({
        dataDealer: newConvertDatas
      }, () => {
        callback()
      });
    })
  }

  handleUserViewDetail = (indexData)=>{
    this.props.callbacksetTabIndex(1) 
    this.props.callbackSetCurrentData(this.state.dataListRaw[indexData])
  }

  handleChangeAutoComplete = name => value => {  
    this.setState({
      [name] : value,
    },()=>{
    });
  };
  handleChangeState = (name,value) => {  
    this.setState({
      [name] : value,
    },()=>{
    });
  };
  handleSearch = ()=>{
    const dateS = this.state.startDateTime ? this.state.startDateTime : ""
    const dateE = this.state.endDateTime ? new Date(new Date(this.state.endDateTime).getTime() + 86399000).toISOString() : ""
    if(dateS != "" && new Date(dateS).getTime() >= new Date(dateE).getTime()){
      WarningCallback('"วันที่เริ่ม" ต้องน้อยหรือเท่ากับ "ถึงวันที่" ...!')
      return
    }else if(
      ( dateS != "" && dateE == "") || 
      ( dateS == "" && dateE != "")  
    ){
      WarningCallback('เมื่อเลือกวันที่แล้วต้องเลือกให้ครบทั้ง "วันที่เริ่ม" และ  "ถึงวันที่" ...!')
      return 
    }

    Alert.Loading(true)
    var dealer_code = ""
    if(this.state.currentBranchName != ""){
      if(this.state.currentBranchName.length > 0){
        this.state.currentBranchName.map((data,index)=>{
          if(index != 0){
            dealer_code += ","
          }
          dealer_code += data.value 
        })
      }  
    } 
    this.props.listsCustomerSurveyUpdate(this.state.currentLeadName,this.state.currentLimit,this.state.currentFocusStatus,false,this.props.isSuccessCase,this.props.isSuccessQcCheck,this.props.isSuccessQcPass,dateS,dateE,dealer_code)
  }

  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }

  handleDialogOpen = (index) => {
    console.log(this.state.dataListRaw[index])
    this.setState({
      currentData: this.state.dataListRaw[index],
      currentUserName: this.state.dataListRaw[index].first_name + " " + this.state.dataListRaw[index].last_name
    }, () => {
      this.setState({ statusDialogOpen: true })
      console.log(this.state.dataListRaw[index])
    })
    
  }

  handleDialogClose = () => {
    this.setState({ statusDialogOpen: false })
  }

  loopDataQuetions = (datas) => { 
    if (!datas || !datas.question_id || !datas.question_id.answers_obj ) return
    var data = JSON.parse(datas.question_id.answers_obj)
    if (!data.sc1) return
    data = data.sc1
    var res = [] 
    var sort_data = {}
    for (let index = 1; index <= 26; index++) {
      if (data["q" + index] != undefined) {
        sort_data["q" + index] = data["q" + index]
      }
    }
    data = sort_data 
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const c_data = data[key];
        var answer = ""
        switch (data[key].type) {
          case "Radio": 
          case "QRadio":
            answer = data[key].name
            if (data[key].value == 6)
              answer = data[key].comment
            break; 
          case "QButtonPoint":
          case "QSlider":
          case "Input":
            answer = data[key].value
            break; 
          default:
            break;
        } 
        res.push(
          <div>
            <div className="quetions_title">{replaceNumberQuestion(key)}.{this.setBranchName(key,datas,wordingQuestion[key].dataQuestion.th.question)}</div>
            <div className={(answer != "") ? "has_answer" : "not_answer"}>ตอบ : {answer} </div>
            <div className="hr-q"></div>
          </div>
        )
      }
    }
    return res
  }

  setBranchName = (key,data,txt)=> {
    if( key == "q1"){ 
      return txt.replace("<?{branch_name}?>",data.branch_name)
    }else{
      return txt
    }
  } 

  renderListData = data => {
    return data.map((CData, key) => { 
      var status_name = "-" 
      switch (CData.res_status) {
        case 1: 
          status_name = "รอ QC ตรวจ"
          break; 
        case 2:
          status_name = "QC ผ่าน"
          break; 
        case 3:
          status_name = "QC ไม่ผ่าน"
          break;  
        case 4:
          status_name = "รอการโทร"
          break;  
        case 5:
          status_name = "ไม่สำเร็จ"
          break;
      }
      var lead_data = JSON.parse(CData.data)
      var branch_name = "-"
      if(lead_data.Dealer_NameEN){
        branch_name = lead_data.Dealer_NameEN+" ("+ lead_data.Branch_NameEN +")"
      }

      return {
        id: (key + 1),
        status: status_name,
        customerFName: CData.first_name,
        customerLName: CData.last_name,
        phoneNumber: (this.props.isSuccessQcCheck || this.props.isSuccessQcPass) ? CData.tel : CData.tel.substr(0,7)+"XXX",
        leadName: CData.lead_setting_id.description,
        statusName:  (CData.last_call_status) ? CData.last_call_status.description : "New",
        numberOfCall:  CData.called_count, 
        actions: (
          <div 
          // className="actions-right"
          >
            <Button
              // disabled={dataUser.user_type_code === 0 ? true : false}
              // justIcon
              size="sm"
              round
              onClick={() => this.handleUserViewDetail(key)
              }
              color="info"             
            >
              <Tooltip
                id="tooltip-top"
                title="เลือกรายการที่ต้องการ"
                placement="top"
                classes={{ tooltip: this.props.classes.tooltip }}
              >
                <div><EventNoteIcons />  </div>
              </Tooltip>
            </Button>
            
            {
            (userCode != 6 && (this.props.isSuccessQcCheck || this.props.isSuccessQcPass))?
              <Button 
                size="sm"
                round 
                color="success" 
                onClick={e => this.handleDialogOpen(key)}
                >
                <Tooltip
                  id="tooltip-top"
                  title="เลือกดูคำตอบที่ต้องการ"
                  placement="top"
                  classes={{ tooltip: this.props.classes.tooltip }}
                >
                  <div><SearchIcon />  </div>
                </Tooltip>
              </Button>:""
            }
          </div>
        ),
        qcDate:  ISOToDateYMDAndFullTime(CData.last_qc_checked_date_iso),
        finishQuestionDateDate:  CData.question_id?ISOToDateYMDAndFullTime(CData.question_id.finish_question_date):"",
        branch_name: branch_name
      }
    })
  }
  render() {
    const { classes } = this.props
    var datalist_table = null
    if(this.props.isSuccessQcCheck || this.props.isSuccessQcPass){
        datalist_table = [
          {
            Header: "No.",
            accessor: "id",
            width:60
          },  
          { 
            Header: "",
            accessor: "actions",
            sortable: false,
            filterable: false,
            width:150
          },
          {
            Header: "สถานะ",
            accessor: "status",
            width:100
          }, 
          {
            Header: "วันที่ตอบครบ",
            accessor: "finishQuestionDateDate",
            width:150
          },
          {
            Header: "ชื่อข้อมูลนำเข้า",
            accessor: "leadName",
            width:200
          },
          {
            Header: "ชื่อลูกค้า",
            accessor: "customerFName",
            width:150
          },
          {
            Header: "นามสกุลลูกค้า",
            accessor: "customerLName",
            width:150
          },
          {
            Header: "เบอร์โทร",
            accessor: "phoneNumber"
          },
          {
            Header: "สาขา",
            accessor: "branch_name",
            width:350
          },
          {
            Header: "สถานะการโทรล่าสุด",
            accessor: "statusName"
          },
          {
            Header: "จำนวนการโทร",
            accessor: "numberOfCall"
          },
          {
            Header: "วันที่ตรวจสอบ",
            accessor: "qcDate",
            width:150
          },
          {
            Header: "",
            accessor: "-",
            sortable: false,
            filterable: false
          },
          
        ]
    }else{
      datalist_table = [
        {
          Header: "No.",
          accessor: "id",
          width:60
        },  
        { 
          Header: "",
          accessor: "actions",
          sortable: false,
          filterable: false,
          width:150
        },
        {
          Header: "สถานะ",
          accessor: "status",
          width:100
        },
        {
          Header: "ชื่อข้อมูลนำเข้า",
          accessor: "leadName",
          width:200
        },
        {
          Header: "ชื่อลูกค้า",
          accessor: "customerFName",
          width:150
        },
        {
          Header: "นามสกุลลูกค้า",
          accessor: "customerLName",
          width:150
        },
        {
          Header: "เบอร์โทร",
          accessor: "phoneNumber"
        },
        {
          Header: "สถานะการโทรล่าสุด",
          accessor: "statusName"
        },
        {
          Header: "จำนวนการโทร",
          accessor: "numberOfCall"
        },
        {
          Header: "สาขา",
          accessor: "branch_name",
          width:350
        },
        {
          Header: "",
          accessor: "-",
          sortable: false,
          filterable: false
        },  
      ]
    }

    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>รายการ{this.state.pageName}</h4>
              </CardHeader>
              <CardBody>
                <form>
                <GridContainer >
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                      <GridItem xs={12} sm={12} md={6} className="date-responsive">
                        {
                          (userCode != 6 && (this.props.isSuccessQcCheck || this.props.isSuccessQcPass)) ?
                          <div>
                          <InputLabel className={classes.label}>
                            วันที่เริ่ม
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              timeFormat={false}
                              onChange={e => this.handleDateTimeChange("startDateTime", e)}
                              inputProps={{
                                placeholder: "กดเลือกวันที่ตรงนี้", readOnly: true
                              }}
                            />
                          </FormControl>
                          </div>
                          : ""
                        }
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6} className="date-responsive">
                        {
                          (userCode != 6 && (this.props.isSuccessQcCheck || this.props.isSuccessQcPass)) ?
                          <div>
                          <InputLabel className={classes.label}>
                            ถึงวันที่
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              timeFormat={false}
                              onChange={e => this.handleDateTimeChange("endDateTime", e)}
                              inputProps={{ placeholder: "กดเลือกวันที่ตรงนี้", readOnly: true }}
                            />
                          </FormControl>
                          </div>
                          : ""
                        }
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} className="m-tb-2"> 
                          {
                            (this.state.dataLead.length > 0) ? 
                            <Autocomplete
                              handleChange={this.handleChangeAutoComplete}
                              value={this.state.currentLeadName}
                              dataList={this.state.dataLead}
                              multi
                              id ="currentLeadName"
                              label="เลือกข้อมูลที่นำเข้า"
                            />
                            : ""
                          } 
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <span className="description-label">
                            *จะต้องเลือกชื่อข้อมุลที่นำเข้าในรอบนั้นๆ ก่อน ถ้าเลือกจำนวนมากไปจะส่งผลให้ระบบช้าและอาจจะทำให้ข้อมูลเยอะเกิน RAM ของเครื่องคุณที่สามารถรับได้ 
                          </span> 
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} className={"autocomplete-space"}>
                            <GridContainer > 
                              <GridItem xs={12} sm={12} md={12}>
                                {
                                  (this.state.dataDealer.length > 0) ? 
                                    <Autocomplete
                                      handleChange={this.handleChangeAutoComplete}
                                      value={this.state.currentBranchName}
                                      dataList={this.state.dataDealer}
                                      multi
                                      id ="currentBranchName"
                                      label="เลือกสาขา"
                                    />
                                    : ""
                                }
                              </GridItem>
                              </GridContainer>
                          </GridItem>
                        <GridItem xs={12} sm={3}> 
                        {/* <GridItem xs={12} sm={userCode == 6 || this.props.isSuccessCase || this.props.isSuccessQcCheck || this.props.isSuccessQcPass?6:3}>  */}
                          <Select
                            label="จำนวนที่แสดง"
                            value={this.state.currentLimit}
                            listData={this.state.limitList}
                            onChange={ e => this.handleChangeState("currentLimit",e.target.value)}
                          />
                        </GridItem>
                        {/* {
                          ( userCode != 6 && !this.props.isSuccessCase && !this.props.isSuccessQcCheck && !this.props.isSuccessQcPass)? */}
                          <GridItem xs={12} sm={3}> 
                            <Select
                              label="สถานะ"
                              value={this.state.currentFocusStatus}
                              listData={this.state.focusStatusList}
                              onChange={ e => this.handleChangeState("currentFocusStatus",e.target.value)}
                            />
                          </GridItem>
                          {/* :""
                        } */}
                        <GridItem xs={12} sm={6}> 
                          <Button
                            round
                            color="primary"
                            onClick={e=>this.handleSearch()}
                            className={"button-search"}
                          >
                            <SearchIcon className={classes.icons} />
                            ค้นหา
                          </Button>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                </GridContainer>
                <hr/>
                <span>จำนวน {thaiBath(this.state.dataList.length,false)} รายการ จากทั้งหมด {this.state.dataListMaxFormServer}</span> 
                <ReactTable
                  data={this.state.dataList}
                  filterable 
                  columns={datalist_table}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight table-scroll"
                />
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <Dialog
          open={this.state.statusDialogOpen}
          // onClick={e => this.handleDialogClose()}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title">
            {
              (
                userCode != 2 &&
                userCode != 3 &&
                userCode != 4  
              )?this.state.currentUserName:""
            }
          </DialogTitle>
          <DialogContent dividers={true}>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
            >
              {
                (this.state.currentData !== {} && this.state.currentData != "{}") ?
                  <div>{this.loopDataQuetions(this.state.currentData)}</div>
                  // <div>

                  //   <h5>{wordingQuestion.q1.dataQuestion.th.question}</h5>
                  //   <span>ตอบ : {(this.state.currentData.sc1)?this.state.currentData.sc1.q1.name:""}</span>

                  // </div>
                  : ""
              }

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={e => { this.handleDialogClose() }} color="primary">
              Cancel
              </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

function mapStateToProps({ listsCustomerSurvey }) {
  return {
    listsCustomerSurvey: listsCustomerSurvey
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsCustomerSurveyUpdate }
  )
)(ProjectListManagement)
